import request from '@/network/http'

export function getCheckupSubjectList(data) {
    return request({
        url: 'Evaluation/CheckupProject/getCheckupSubjectList',
        method: 'post',
        data
    })
}

export function getCheckupSubjectItemList(data) {
    return request({
        url: 'Evaluation/CheckupProject/getCheckupSubjectItemList',
        method: 'post',
        data
    })
}

export function getCheckupSubjectItemInfo(data) {
    return request({
        url: 'Evaluation/CheckupProject/getCheckupSubjectItemInfo',
        method: 'post',
        data
    })
}

export function getCheckupEvaluationProjectTypeList() {
    return request({
        url: 'Base/CheckupProject/getCheckupEvaluationProjectTypeList',
        method: 'post',
    })
}

export function getCheckupObjectTypeList() {
    return request({
        url: 'Base/CheckupProject/getCheckupObjectTypeList',
        method: 'post',
    })
}

export function notInvolvedCheckupSubjectItemEvaluation(data) {
    return request({
        url: 'Evaluation/CheckupProject/notInvolvedCheckupSubjectItemEvaluation',
        method: 'post',
        data
    })
}

export function finishCheckupSubjectItemEvaluation(data) {
    return request({
        url: 'Evaluation/CheckupProject/finishCheckupSubjectItemEvaluation',
        method: 'post',
        data
    })
}

export function saveCheckupSubjectItemEvaluationInfo(data) {
    return request({
        url: 'Evaluation/CheckupProject/saveCheckupSubjectItemEvaluationInfo',
        method: 'post',
        data
    })
}

export function getCheckupProjectFileCategoryList(data) {
    return request({
        url: 'Checkup/CheckupFile/getCheckupProjectFileCategoryList',
        method: 'post',
        data,
        identity_type:1
    })
}

export function checkItemEvaluationDel(data) {
  return request({
      url: 'Evaluation/CheckupProject/checkItemEvaluationDel',
      method: 'post',
      data
  })
}

export function saveCheckItemScore(data) {
  return request({
      url: 'Evaluation/CheckupProject/saveCheckItemScore',
      method: 'post',
      data
  })
}


// WEBPACK FOOTER //
// ./src/apis/expert.js